<template>
  <button
    class="st-back-button"
    tabindex="0"
    @click="useRoute ? $router.push(route) : $router.go(-1)"
    type="button"
  >
    <st-icon name="chevron" size="small" />
    <span class="st-back-button__text">{{ text }}</span>
  </button>
</template>

<script>
import StIcon from "../icon/Icon.vue";

export default {
  name: "st-back-button",
  created() {
    console.warn(
      "Warning: BackButton is deprecated. Use Button or Link instead.",
    );
  },
  props: {
    route: String,
    useRoute: {
      default: true,
      type: Boolean,
    },
    text: {
      type: String,
      default: "Tillbaka",
    },
  },
  components: {
    StIcon,
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

.st-back-button {
  all: unset;
  background-color: var(--background-color-secondary);
  border-radius: rem-calc(20);
  box-shadow: 0 rem-calc(2) rem-calc(4) 0 rgba(0, 0, 0, 0.1);
  display: inline-flex;
  padding: rem-calc(2) rem-calc(12);
  align-items: center;
  cursor: pointer;
  transition: box-shadow 0.2s ease-in-out;
  &:focus {
    outline: rem-calc(1) solid var(--border-color-quaternary);
  }
  &:hover {
    box-shadow: 0 rem-calc(5) rem-calc(5) 0 rgba(0, 0, 0, 0.15);
  }
  .st-icon {
    transform: rotate(90deg);
  }
  &__text {
    margin-left: rem-calc(4);
    font-family: var(--font-primary);
    font-size: rem-calc(14);
    color: var(--text-color-primary);
    &:hover {
      color: var(--text-color-interactive);
    }
  }
}
</style>
